export class VisualizarImagemOriginalRespostaModel {
  IdentificadorCameraMPI: string;
  PlacaOcrConfianca: number;
  PlacaIlegivel: boolean;
  MotivoCorrecaoOCR: string;
  DescricaoFormatada: string;
  CaminhoAbsolutoArquivoProcessadoServidorSolicitacaoNome: string;
  CaminhoAbsolutoArquivoOriginalServidorSolicitacaoNome: string;
  ExisteCoordenadas: string;
  ExisteCoordenadasBool: boolean;
  RegiaoNome: string;
  ImagemQualidade: number;
  ImagemAltura: number;
  ImagemLargura: number;
  TamanhoBytes: number;
  TamanhoKbytes: number;
  VideoBitRate: number;
  VideoFrameRate: number;
  VideoDuracao: number;
  VideoDuracaoString: string;
  VideoCodec: string;
  PlacaOcr: string;
  ProcessarOcr: boolean;
  InformacaoAdicionalLaudo: string;
  CapturaPorUrl: boolean;
  Id: string;
  LaudoVistoriaProcessoId: string;
  StorageArquivoOriginalId: string;
  StorageArquivoProcessadoId: string;
  ImagemCapturadaDataHora: Date;
  ImagemCapturadaDataHoraString: string;
  ImagemLocalizacaoTipo: string;
  RegiaoProtocolo: string;
  VideoKeyFrameIntervalo: number;
  RegiaoServico: string;
  ArquivoNomeOriginal: string;
  CaminhoAbsolutoArquivoProcessado: string;
  CaminhoAbsolutoArquivoOriginalParametros: string;
  CaminhoAbsolutoArquivoOriginal: string;
  Ordem: number;
  ImagemLocalizacaoNome: string;
  ContemInformacao: boolean;
  ExibeInformacao: boolean;
  Informacao: string;
  RegiaoDominio: string;
  Latitude: number;
  Longitude: number;
}
